module.exports = __webpack_public_path__ + "static/img/30001 (5).8a6cbfe.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30001 (5).webp
// module id = CoBw
// module chunks = 14